import React, { useState } from 'react';
import { Sec, SH } from '../components/Section';
import { C } from '../constants';
import { useTheme } from '../contexts/ThemeContext';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from '../components/BrandIcons';

const FAQI = ({ q, a, isOpen, onToggle }) => {
  const { theme } = useTheme();

  return (
    <div
      style={{
        background: isOpen ? (theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)') : 'transparent',
        border: `1px solid ${isOpen ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)'}`,
        borderRadius: '16px',
        padding: '24px',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
      }}
      onClick={onToggle}
      data-testid="faq-item"
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
        <h4 style={{ fontSize: '18px', fontWeight: 700, fontFamily: "'Sansation', sans-serif", flex: 1 }}>
          {q}
        </h4>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          style={{ flexShrink: 0 }}
        >
          {isOpen ? <MinusIcon size={24} /> : <PlusIcon size={24} />}
        </motion.div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            style={{ overflow: 'hidden' }}
          >
            <p
              className="font-[Manrope]"
              style={{
                fontSize: '15px',
                lineHeight: 1.6,
                opacity: 0.8,
                marginTop: '16px'
              }}
            >
              {a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const FAQWidget = () => {
  const { theme } = useTheme();
  const [openIndex, setOpenIndex] = useState(null);

  // Exact original FAQ content
  const faqs = [
    {
      q: 'What is DecX AI?',
      a: 'DecX AI is a deck intelligence platform that helps founders and B2B teams score, improve, and close with their presentations. We provide AI-powered analysis, audience insights, and ready-to-use artefacts for pitch, sales, and product decks.'
    },
    {
      q: 'How does the free DecX Score work?',
      a: 'Upload your deck (PDF, PPTX, or Google Slides). Our AI analyzes it across 5 dimensions and delivers your score with top 3 issues within 24 hours. No credit card required.'
    },
    {
      q: 'What are credits?',
      a: 'Credits are the currency of DecX AI. You use credits to access deeper intelligence, insights, and artefacts. Start free, then buy credits as you need them.'
    },
    {
      q: 'What deck types do you analyze?',
      a: 'Pitch decks (fundraising), sales decks (closing deals), product decks (stakeholder buy-in), partner decks, board decks — any presentation that needs a yes.'
    },
    {
      q: 'How is this different from ChatGPT?',
      a: 'LLMs give generic suggestions. DecX AI gives you a consistent scoring system benchmarked on 1,000+ decks, audience-specific insights, and ready-to-use closing artefacts. Plus human expert review.'
    },
    {
      q: 'Is my deck confidential?',
      a: 'Yes. 100% confidential. We never share, publish, or use your deck for anything other than your analysis.'
    },
    {
      q: 'Can you build my deck for me?',
      a: 'Yes. Slidr is our done-for-you service. Strategy, narrative, and design. Starting at $779.'
    }
  ];

  return (
    <Sec id="faq" dark={theme === 'light'}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <SH
          eyebrow="FAQ"
          title="Questions?"
          accent="Answers."
          center
        />

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '48px' }}>
          {faqs.map((faq, i) => (
            <FAQI
              key={i}
              q={faq.q}
              a={faq.a}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? null : i)}
            />
          ))}
        </div>
      </div>
    </Sec>
  );
};
